/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ShippingFees {
  angular.module('meevo.plugins.shippingFees', []);
}